// extracted by mini-css-extract-plugin
export default {"headerBar":"EditSharedDecision_headerBar__f-fU9"};